// ----------------- SHARED HELPERS -------------------------------------------

// Google Merchant Center ID for basket data. Leave empty until confirmed;
// when empty, cart data is skipped and only customer data is added.
var BREEZE_GADS_MERCHANT_ID = "5539169258";

// Sends customer details to Google for Enhanced Conversions (Google hashes them in the browser)
function breezeSetGoogleUserData(params) {
  try {
    var user = (params && params.userDetails) || {};
    var phone = user.phone ? String(user.phone).replace(/[^0-9]/g, "") : "";
    var countryCode = user.countryCode ? String(user.countryCode).replace(/[^0-9]/g, "") : "91";
    var userData = {};
    if (user.email) {
      userData.email = String(user.email).trim().toLowerCase();
    }
    if (phone) {
      userData.phone_number = "+" + countryCode + phone.slice(-10);
    }
    if (user.firstName || user.lastName || user.postalCode) {
      userData.address = {
        first_name: user.firstName || "",
        last_name: user.lastName || "",
        city: user.city || "",
        region: user.state || "",
        postal_code: user.postalCode || "",
        country: "IN"
      };
    }
    if (Object.keys(userData).length > 0) {
      window.gtag("set", "user_data", userData);
    }
  } catch (e) {
    console.log("Error in setting google user data : ", e);
  }
}

// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-16845084310");

  breezeSetGoogleUserData(params);

  var conversionData = {
    send_to: ["AW-16845084310/OCVvCJyA1ZkaEJatruA-"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze"
  };
  if (BREEZE_GADS_MERCHANT_ID && Array.isArray(params.items)) {
    conversionData.aw_merchant_id = BREEZE_GADS_MERCHANT_ID;
    conversionData.aw_feed_country = "IN";
    conversionData.aw_feed_language = "en";
    conversionData.items = params.items.map(function (item) {
      return {
        id: "shopify_IN_" + item.id + "_" + item.variant,
        price: item.price,
        quantity: item.quantity
      };
    });
  }
  window.gtag("event", "purchase", conversionData);
  // GOOGLE ADS PURCHASE EVENT CODE END

}

// ----------------- END PURCHASE SCRIPT --------------------------------------


// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------

// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-16845084310");

  breezeSetGoogleUserData(params);

  window.gtag("event", "conversion", {
    send_to: ["AW-16845084310/Wdc2CLHDw5kaEJatruA-"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze"
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------
